// AI Assistant Plugin for Froala Editor - Performance Optimized (Final Version)
import FroalaEditor from 'froala-editor';
import { sendChatMessage } from '../../../widgetArea/api';

// Global flag to prevent multiple style injections
let globalStylesAdded = false;

FroalaEditor.PLUGINS.aiAssistant = function (editor) {
  let messageIdentifier: string = null;
  let isDraftIncluded: boolean = true;
  let projectId: string = null;
  let isAIFeaturesEnabled: boolean = false;
  let messageSubject: string = null;
  let isProcessing: boolean = false;
  let lastPrompt: string = '';
  let savedSelection: any = null;

  // Store event listeners for cleanup
  let eventListeners: Array<{
    element: HTMLElement;
    event: string;
    handler: Function;
  }> = [];

  function _init() {
    // Only add styles once globally
    if (!globalStylesAdded) {
      _addStyles();
      globalStylesAdded = true;
    }

    // Event Delegation für alle AI-Content-Bereiche
    _setupGlobalClickHandler();
  }

  function _addStyles() {
    if (document.getElementById('fr-ai-assistant-styles')) return;

    const styleTag = document.createElement('style');
    styleTag.id = 'fr-ai-assistant-styles';
    styleTag.textContent = `
    .fr-ai-inline-modal {
      position: fixed;
      background: var(--prio_background_content, white);
      border-radius: 6px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      min-width: 360px;
      max-width: 520px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
      border: 1px solid var(--prio_borders_colors_content, #e1e5e9);
      opacity: 0;
      transform: translateY(-8px);
      transition: opacity 0.15s ease, transform 0.15s ease;
      will-change: opacity, transform;
    }

    .fr-ai-inline-modal.visible {
      opacity: 1;
      transform: translateY(0);
    }

    .fr-ai-inline-header {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border-bottom: 1px solid var(--prio_borders_colors_content, #e1e5e9);
      background: var(--prio_background_base, #2b3d4e);
      color: white;
      border-radius: 6px 6px 0 0;
    }

    .fr-ai-inline-icon {
      width: 18px;
      height: 18px;
      margin-right: 8px;
      background: var(--prio_background_content, white);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      color: var(--prio_primary, #1252c0);
      font-weight: 700;
    }

    .fr-ai-inline-title {
      font-size: 14px;
      font-weight: 600;
      flex: 1;
    }

    .fr-ai-inline-close {
      background: none;
      border: none;
      color: white;
      font-size: 18px;
      cursor: pointer;
      padding: 4px;
      border-radius: 3px;
      opacity: 0.8;
      transition: opacity 0.1s ease;
    }

    .fr-ai-inline-close:hover {
      opacity: 1;
      background: rgba(255, 255, 255, 0.1);
    }

    .fr-ai-inline-body {
      padding: 16px;
      background: var(--prio_background_content, white);
    }

    .fr-ai-inline-input {
      width: 100%;
      min-height: 72px;
      padding: 12px;
      border: 2px solid var(--prio_borders_colors_content, #e1e5e9);
      border-radius: 6px;
      font-size: 14px;
      line-height: 1.4;
      resize: vertical;
      font-family: inherit;
      margin-bottom: 12px;
      color: #333;
      background: var(--prio_background_content, white);
      transition: border-color 0.1s ease;
    }

    .fr-ai-inline-input:focus {
      outline: none;
      border-color: var(--prio_primary, #1252c0);
    }

    .fr-ai-inline-suggestions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 12px;
    }

    .fr-ai-inline-suggestion {
      background: var(--prio_background_sub, #f5f6f7);
      border: 1px solid var(--prio_borders_colors_content, #e1e5e9);
      border-radius: 16px;
      padding: 6px 10px;
      font-size: 12px;
      cursor: pointer;
      color: #495057;
      font-weight: 500;
      transition: all 0.1s ease;
    }

    .fr-ai-inline-suggestion:hover {
      background: var(--prio_background_hover_sub, #e8eaec);
      border-color: var(--prio_primary, #1252c0);
      color: var(--prio_primary, #1252c0);
    }

    .fr-ai-inline-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
    }
.fr-ai-inline-actions > div:last-child {
    display:        flex;   
    flex-direction: row;
    align-items:    center;
    gap:            12px;      
    flex-wrap:      nowrap;    
}

.fr-ai-inline-actions > div:last-child .fr-ai-inline-btn {
    min-width: auto;
}
    .fr-ai-inline-btn {
      padding: 8px 16px;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      border: none;
      display: flex;
      align-items: center;
      gap: 6px;
      font-family: inherit;
      line-height: 1.4;
      min-height: 32px;
      transition: all 0.1s ease;
    }

    .fr-ai-inline-btn-primary {
      background: var(--prio_primary, #1252c0);
      color: white;
    }

    .fr-ai-inline-btn-primary:disabled {
      background: #6c757d;
      cursor: not-allowed;
    }

    .fr-ai-inline-btn-secondary {
      background: transparent;
      color: #6c757d;
      border: 1px solid var(--prio_borders_colors_content, #e1e5e9);
    }

    .fr-ai-inline-loading {
      display: none;
      align-items: center;
      color: #6c757d;
      font-size: 12px;
      font-weight: 500;
    }

    .fr-ai-inline-loading.active {
      display: flex;
    }

    .fr-ai-inline-spinner {
      width: 14px;
      height: 14px;
      margin-right: 8px;
      border: 2px solid var(--prio_borders_colors_content, #e1e5e9);
      border-radius: 50%;
      border-top-color: var(--prio_primary, #1252c0);
      animation: ai-loading-spin 1s linear infinite;
    }

    @keyframes ai-loading-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .prio-ai-content {
      position: relative;
      border-left: 3px solid var(--prio_primary, #1252c0);
      padding-left: 12px;
      margin: 8px 0;
      background: rgba(18, 82, 192, 0.02);
      cursor: pointer;
      transition: background-color 0.1s ease;
    }

    .prio-ai-content::before {
      content: "✨ Prio Buddy - Klicken zum Entfernen der Markierung";
      position: absolute;
      top: -18px;
      left: 0;
      font-size: 10px;
      color: var(--prio_primary, #1252c0);
      font-weight: 600;
      background: var(--prio_background_content, white);
      padding: 2px 6px;
      border-radius: 8px;
      border: 1px solid rgba(18, 82, 192, 0.2);
      cursor: pointer;
      transition: all 0.1s ease;
    }

    .prio-ai-content:hover {
      background: rgba(18, 82, 192, 0.05);
    }

    .prio-ai-content:hover::before {
      color: var(--prio_primary, #1252c0);
      background: rgba(18, 82, 192, 0.1);
    }

    /* Reduced animation duration for better performance */
    @keyframes ai-content-fade-in {
      from { 
        background-color: rgba(18, 82, 192, 0.1);
        transform: translateX(-2px);
      }
      to { 
        background-color: rgba(18, 82, 192, 0.02);
        transform: translateX(0);
      }
    }

    .prio-ai-content {
      animation: ai-content-fade-in 0.3s ease-out;
    }
  `;

    document.head.appendChild(styleTag);
  }

  function _setupGlobalClickHandler() {
    try {
      // Verwende Event Delegation auf dem Editor-Container
      const editorContainer = editor.$el[0];
      if (editorContainer) {
        // Entferne bestehenden Handler
        editorContainer.removeEventListener('click', _globalClickHandler);
        // Füge neuen Handler hinzu
        editorContainer.addEventListener('click', _globalClickHandler, true); // true = capturing phase
        eventListeners.push({
          element: editorContainer,
          event: 'click',
          handler: _globalClickHandler,
        });
      }
    } catch (error) {
      console.error('Error setting up global click handler:', error);
    }
  }

  // Optimierter Global Click Handler
  function _globalClickHandler(event: Event) {
    const target = event.target as HTMLElement;

    // Ignoriere häufige Editor-Interaktionen für bessere Performance
    if (
      target.closest('.fr-toolbar') ||
      target.closest('.fr-popup') ||
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA'
    ) {
      return;
    }

    // Nur bei tatsächlichen Content-Klicks prüfen
    if (target.closest('.fr-element')) {
      let aiContentElement = target.closest('.prio-ai-content') as HTMLElement;

      if (aiContentElement) {
        event.preventDefault();
        event.stopPropagation();
        _removeAiMarking(aiContentElement);
        return false;
      }
    }
  }

  // Optimized function with memoization
  const _isReplyMessage = (() => {
    let cachedResult: boolean | null = null;
    let lastSubject: string | null = null;

    return (): boolean => {
      if (messageSubject === lastSubject && cachedResult !== null) {
        return cachedResult;
      }

      lastSubject = messageSubject;

      if (!messageSubject || typeof messageSubject !== 'string') {
        cachedResult = false;
        return false;
      }

      const replyPrefixes = ['AW:', 'RE:', 'ANT:', 'SV:', 'VS:', 'WG:'];
      const subject = messageSubject.trim().toUpperCase();
      cachedResult = replyPrefixes.some((prefix) => subject.startsWith(prefix));

      return cachedResult;
    };
  })();

  function _openInlineModal() {
    if (!isAIFeaturesEnabled || isProcessing) return;

    // Clean up any existing modal first
    _cleanupModal();

    savedSelection = editor.selection.save();

    const isNewEmail = !_isReplyMessage();
    const modal = document.createElement('div');
    modal.className = 'fr-ai-inline-modal';

    // Check if we have existing AI content to replace
    const hasExistingAiContent = !!document.querySelector('.prio-ai-content');
    const buttonText = hasExistingAiContent ? 'Überarbeiten' : 'Erstellen';

    modal.innerHTML = `
      <div class="fr-ai-inline-header">
        <div class="fr-ai-inline-icon">AI</div>
        <div class="fr-ai-inline-title">Prio Buddy ${hasExistingAiContent ? '- Text überarbeiten' : ''}</div>
        <button class="fr-ai-inline-close" type="button">×</button>
      </div>
      <div class="fr-ai-inline-body">
        <textarea 
          class="fr-ai-inline-input" 
          placeholder="${isNewEmail ? 'Was möchten Sie schreiben?' : 'Wie möchten Sie antworten?'}"
          rows="3"
        ></textarea>
        <div class="fr-ai-inline-suggestions">
          ${_getSuggestions(isNewEmail)
            .map(
              (suggestion) =>
                `<div class="fr-ai-inline-suggestion" data-suggestion="${suggestion}">${suggestion}</div>`
            )
            .join('')}
        </div>
        <div class="fr-ai-inline-actions">
          <div>
            <button class="fr-ai-inline-btn fr-ai-inline-btn-secondary" data-action="reuse-last" ${!lastPrompt ? 'style="display:none"' : ''}>
              ↻ Wiederholen
            </button>
            <div class="fr-ai-inline-loading">
              <div class="fr-ai-inline-spinner"></div>
              Generiert...
            </div>
          </div>
          <div>
            <button class="fr-ai-inline-btn fr-ai-inline-btn-secondary" data-action="cancel">
              Abbrechen
            </button>
            <button class="fr-ai-inline-btn fr-ai-inline-btn-primary" data-action="generate" disabled>
              ${buttonText}
            </button>
          </div>
        </div>
      </div>
    `;

    _positionModal(modal);
    _attachEventListeners(modal);

    document.body.appendChild(modal);

    // Use requestAnimationFrame for smooth animation
    requestAnimationFrame(() => {
      modal.classList.add('visible');
      const input = modal.querySelector(
        '.fr-ai-inline-input'
      ) as HTMLTextAreaElement;
      if (input) {
        input.focus();
      }
    });
  }

  function _cleanupModal() {
    const existingModal = document.querySelector('.fr-ai-inline-modal');
    if (existingModal) {
      existingModal.remove();
    }
    _cleanupEventListeners();
  }

  function _cleanupEventListeners() {
    eventListeners.forEach(({ element, event, handler }) => {
      if (element && typeof element.removeEventListener === 'function') {
        element.removeEventListener(event, handler as EventListener);
      }
    });
    eventListeners = [];
  }

  function _addEventListenerWithCleanup(
    element: HTMLElement,
    event: string,
    handler: Function
  ) {
    element.addEventListener(event, handler as EventListener);
    eventListeners.push({ element, event, handler });
  }

  function _attachEventListeners(modal: HTMLElement) {
    const input = modal.querySelector(
      '.fr-ai-inline-input'
    ) as HTMLTextAreaElement;
    const generateBtn = modal.querySelector(
      '[data-action="generate"]'
    ) as HTMLButtonElement;

    // Modal click handler
    const modalClickHandler = (e: Event) => {
      const target = e.target as HTMLElement;

      if (
        target.classList.contains('fr-ai-inline-close') ||
        target.dataset.action === 'cancel'
      ) {
        _closeInlineModal(modal);
      } else if (target.dataset.action === 'generate') {
        _generateContent(input.value.trim(), modal);
      } else if (target.dataset.action === 'reuse-last') {
        input.value = lastPrompt;
        input.focus();
        generateBtn.disabled = false;
      } else if (target.classList.contains('fr-ai-inline-suggestion')) {
        input.value = target.dataset.suggestion || '';
        input.focus();
        generateBtn.disabled = false;
      }
    };

    // Input handlers
    const inputHandler = () => {
      generateBtn.disabled = input.value.trim().length === 0;
    };

    const keydownHandler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        e.preventDefault();
        if (input.value.trim()) {
          _generateContent(input.value.trim(), modal);
        }
      } else if (e.key === 'Escape') {
        _closeInlineModal(modal);
      }
    };

    // Add event listeners with cleanup tracking
    _addEventListenerWithCleanup(modal, 'click', modalClickHandler);
    _addEventListenerWithCleanup(input, 'input', inputHandler);
    _addEventListenerWithCleanup(input, 'keydown', keydownHandler);
  }

  function _positionModal(modal: HTMLElement) {
    try {
      const modalWidth = 400;
      const modalHeight = 300;

      const left = Math.max(10, (window.innerWidth - modalWidth) / 2);
      const top = Math.max(10, (window.innerHeight - modalHeight) / 2);

      modal.style.left = left + 'px';
      modal.style.top = top + 'px';
    } catch (error) {
      console.error('Modal positioning error:', error);
      modal.style.left = '50%';
      modal.style.top = '50%';
      modal.style.transform = 'translate(-50%, -50%)';
    }
  }

  // Memoized suggestions
  const suggestionCache = new Map();
  function _getSuggestions(isNewEmail: boolean): string[] {
    const cacheKey = isNewEmail ? 'new' : 'reply';

    if (suggestionCache.has(cacheKey)) {
      return suggestionCache.get(cacheKey);
    }

    const suggestions = isNewEmail
      ? [
          'Professionelle E-Mail verfassen',
          'Terminanfrage erstellen',
          'Projekt-Update schreiben',
        ]
      : ['Höflich antworten', 'Freundlich ablehnen', 'Termin bestätigen'];

    suggestionCache.set(cacheKey, suggestions);
    return suggestions;
  }

  function _closeInlineModal(modal: HTMLElement) {
    modal.classList.remove('visible');

    const closeTimeout = setTimeout(() => {
      if (modal.parentNode) {
        modal.parentNode.removeChild(modal);
      }
      _cleanupEventListeners();

      if (savedSelection) {
        try {
          editor.selection.restore(savedSelection);
          editor.events.focus();
        } catch (e) {
          console.warn('Could not restore selection:', e);
        }
      }
    }, 150);

    // Store timeout for potential cleanup
    modal.dataset.closeTimeout = closeTimeout.toString();
  }

  async function _generateContent(prompt: string, modal: HTMLElement) {
    if (!prompt || isProcessing) return;

    try {
      isProcessing = true;
      lastPrompt = prompt;

      const loadingDiv = modal.querySelector('.fr-ai-inline-loading');
      const generateBtn = modal.querySelector(
        '[data-action="generate"]'
      ) as HTMLButtonElement;

      if (loadingDiv) loadingDiv.classList.add('active');
      if (generateBtn) generateBtn.disabled = true;

      const isNewMail = !_isReplyMessage();
      const type = isNewMail ? 'NewEmailAi' : 'EmailResponseAi';

      const { data, result } = await sendChatMessage(
        prompt,
        type,
        messageIdentifier,
        isDraftIncluded,
        projectId
      );

      if (result.ok && data) {
        _closeInlineModal(modal);
        // Use a shorter timeout for better UX
        setTimeout(() => _insertGeneratedContentAtCursor(data), 50);
      } else {
        throw new Error(`API call failed`);
      }
    } catch (error) {
      console.error('AI error:', error);
      const loadingDiv = modal.querySelector('.fr-ai-inline-loading');
      if (loadingDiv) {
        loadingDiv.innerHTML =
          '<div style="color: #dc3545;">Fehler. Bitte erneut versuchen.</div>';
        setTimeout(() => {
          loadingDiv.classList.remove('active');
          const generateBtn = modal.querySelector(
            '[data-action="generate"]'
          ) as HTMLButtonElement;
          if (generateBtn) generateBtn.disabled = false;
        }, 2000);
      }
    } finally {
      isProcessing = false;
    }
  }

  function _insertGeneratedContentAtCursor(content: string) {
    try {
      editor.events.focus();

      const existingAiContent = editor.$el[0].querySelector('.prio-ai-content');

      if (existingAiContent) {
        const formattedContent = _formatContentWithNewlines(content);
        const newContentId = 'prio-ai-' + Date.now();
        const wrappedContent = `<div class="prio-ai-content" id="${newContentId}" data-ai-content="true">${formattedContent}</div>`;

        existingAiContent.outerHTML = wrappedContent;

        const newElement = editor.$el[0].querySelector(`#${newContentId}`);
        if (newElement) {
          editor.selection.setAfter(newElement);
        }
      } else {
        if (savedSelection) {
          editor.selection.restore(savedSelection);
        }

        const formattedContent = _formatContentWithNewlines(content);
        const contentId = 'prio-ai-' + Date.now();
        const wrappedContent = `<div class="prio-ai-content" id="${contentId}" data-ai-content="true">${formattedContent}</div>`;

        editor.html.insert(wrappedContent, false);

        setTimeout(() => {
          const insertedElement = editor.$el[0].querySelector(`#${contentId}`);
          if (insertedElement) {
            editor.selection.setAfter(insertedElement);
          }
        }, 10);
      }

      // Trigger content changed event with debouncing
      _debouncedContentChanged();
    } catch (error) {
      console.error('Insert error:', error);
    }
  }

  // Debounced content changed to reduce excessive event firing
  let contentChangedTimeout: number;
  const _debouncedContentChanged = () => {
    clearTimeout(contentChangedTimeout);
    contentChangedTimeout = window.setTimeout(() => {
      editor.events.trigger('contentChanged');
    }, 50); // Reduziert von 100ms auf 50ms für bessere Responsivität
  };

  function _removeAiMarking(aiElement: HTMLElement) {
    if (!aiElement) return;

    try {
      // Extrahiere nur den Textinhalt ohne die AI-Wrapper
      const content = aiElement.innerHTML;

      // Erstelle ein temporäres Div um den Inhalt zu parsen
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = content;

      // Hole den bereinigten Inhalt
      const cleanContent = tempDiv.innerHTML;

      // Erstelle neues normales Div mit dem Inhalt
      const newDiv = document.createElement('div');
      newDiv.innerHTML = cleanContent;

      // Ersetze das AI-Element
      if (aiElement.parentNode) {
        aiElement.parentNode.replaceChild(newDiv, aiElement);
        _debouncedContentChanged();
      }
    } catch (error) {
      console.error('Error removing AI marking:', error);
    }
  }

  function _formatContentWithNewlines(content: string): string {
    if (!content) return '';

    try {
      let text = content.replace(/\\n/g, '\n').replace(/\r\n/g, '\n');
      const paragraphs = text.split(/\n\s*\n/);
      const formattedParagraphs = paragraphs
        .map((paragraph) => {
          const trimmedParagraph = paragraph.trim().replace(/\n/g, '<br>');
          return trimmedParagraph === '' ? '' : `<p>${trimmedParagraph}</p>`;
        })
        .filter(Boolean);

      return formattedParagraphs.join('');
    } catch (error) {
      console.error('Error formatting content:', error);
      return content;
    }
  }

  function _setConfig(config: any) {
    if (config.messageIdentifier !== undefined)
      messageIdentifier = config.messageIdentifier;
    if (config.isDraftIncluded !== undefined)
      isDraftIncluded = config.isDraftIncluded;
    if (config.projectId !== undefined) projectId = config.projectId;
    if (config.messageSubject !== undefined)
      messageSubject = config.messageSubject;
    if (config.isAIFeaturesEnabled !== undefined)
      isAIFeaturesEnabled = config.isAIFeaturesEnabled;
  }

  function _openAiAssistant() {
    _openInlineModal();
  }

  // Cleanup function for when editor is destroyed
  function _destroy() {
    _cleanupEventListeners();
    _cleanupModal();
  }

  return {
    _init: _init,
    _destroy: _destroy,
    setConfig: _setConfig,
    openAiAssistant: _openAiAssistant,
    openCopilot: _openAiAssistant,
    _checkForPrompt: () => {},
  };
};

export const setupAiAssistantPlugin = (editor: any, options: any = {}) => {
  if (editor && editor.aiAssistant) {
    editor.aiAssistant.setConfig(options);
  }
};

export default FroalaEditor.PLUGINS.aiAssistant;
